import React from 'react'
import StatusIcon from '../../Icons/StatusIcon'
import loadable from '@loadable/component';
import usePostHook from '../../customHooks/useNotificationServicePostHook';
import APIS from '../../constant/EndPoint';
const NotificationListComponent = loadable(
  () => import("../../components/Notification/NotificationList")
);

const NotificationList = () => {
  const { mutateAsync } = usePostHook({
    queryKey: ["notifications"],
    navigateURL: "",
  });


  const handleRead = async (id: string, read: Boolean) => {
    const url = `${APIS.NOTIFICATION}${read ? "read" : "unread"}/`;
    let formData = {
      ids: [id]
    };
    try {
      await mutateAsync({ url, formData });
    } catch (err) {
      console.log(err);
    }
  }


  const handleDelete = async (id: string) => {
    const url = `${APIS.NOTIFICATION}delete/`;
    let formData = {
      ids: [id]
    };
    try {
      await mutateAsync({ url, formData });
    } catch (err) {
      console.log(err);
    }
  }

  return (
    <>
      <div className="w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center">
        <StatusIcon />
        <span className="text-[#5E5757] font-bold text-xl">Notification</span>
      </div>
      <NotificationListComponent
        handleRead={handleRead}
        handleDelete={handleDelete}
      />
    </>
  )
}

export default NotificationList
